import React from "react"
import { useSelector } from "react-redux"
import { Col } from "react-bootstrap"

import { CcRequirementSmartCompliance } from "server/models"
import {
    StoreType,
    SmartCompliancesType,
} from "client/store"
import {
    CheckboxWrapper,
    CheckButton,
} from "client/components"

interface SmartCompliancesProps {
    smartCompliances: SmartCompliancesType
    setSmartCompliances: (smartCompliances: SmartCompliancesType) => void
}

const SmartCompliances = ({
    smartCompliances,
    setSmartCompliances,
}: SmartCompliancesProps) => {
    const complianceList = useSelector((state: StoreType) => state.ccRequirementSmartCompliance.complianceList)
    const complianceIds = useSelector((state: StoreType) => state.ccRequirementSmartCompliance.complianceIds)

    const columnNumber = 3

    const complianceColumnLength = Math.ceil(complianceIds.length / columnNumber)
    const complianceColumns: { [columnIndex: number]: CcRequirementSmartCompliance[] } = {}
    for (let i = 0; i < columnNumber; i++) {
        const column = []
        const start = i * complianceColumnLength
        const end = start + complianceColumnLength
        for (let k = start; k < end; k++) {
            const complianceId = complianceIds[k]
            column.push(complianceList[complianceId])
        }
        complianceColumns[i] = column
    }

    return (
        <CheckboxWrapper>
            {
                Object.keys(complianceColumns).map((index) => (
                    <Col key={index} xs={12} md={12 / columnNumber}>
                        {
                            complianceColumns[Number(index)].map((compliance) => compliance && (
                                <CheckButton
                                    key={compliance.id}
                                    title={compliance.name}
                                    checked={smartCompliances[compliance.id]}
                                    onChange={() => {
                                        const newSmartCompliances = { ...smartCompliances }
                                        newSmartCompliances[compliance.id] = !newSmartCompliances[compliance.id]
                                        setSmartCompliances(newSmartCompliances)
                                    }}
                                />
                            ))
                        }
                    </Col>
                ))
            }
        </CheckboxWrapper>
    )
}
export default SmartCompliances
